<template>
  <b-modal
    id="usage-history-modal"
    ref="historyModal"
    :title="title"
    ok-only
    ok-title="Close"
    size="lg"
  >
    <div>
      <div v-if="loading">
        <Loader />
      </div>
      <div v-if="!loading && historyData.length === 0">
        No changes made to this record
      </div>
      <responsive-table v-if="historyData.length > 0 && !loading">
        <thead class="inline-header">
          <tr>
            <th>
              Changes
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="history in historyData"
            :key="history.id"
          >
            <td>
              {{ history.created_by_name }}
              <span style="font-style: italic;">
                at {{ new Date(history.created).toLocaleString() }}
              </span>
              <table class="table">
                <tr>
                  <th style="width: 36%">
                    Field
                  </th>
                  <th style="width: 32%">
                    Previous
                  </th>
                  <th style="width: 32%">
                    New
                  </th>
                </tr>
                <tbody
                  v-for="key in Object.keys(history.new_value)"
                  :key="key"
                >
                  <tr v-if="history.new_value[key] !== history.previous_value[key]">
                    <td>{{ getKeyDisplayName(key) }}</td>
                    <td>{{ getDisplayValueForKey(key, history.previous_value[key]) }}</td>
                    <td>{{ getDisplayValueForKey(key, history.new_value[key]) }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </responsive-table>
    </div>
  </b-modal>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import Loader from '@/components/Loader.vue';
import ResponsiveTable from '@/components/ResponsiveTable.vue';

export default {
  name: 'HistoryModal',
  components: {
    ResponsiveTable,
    Loader,
  },
  props: {
    dataMapping: {
      type: Object,
    },
  },
  data: () => ({
    loading: false,
    title: 'History',
    historyData: [],
  }),
  methods: {
    show(loadDataPromise, title) {
      if (title) {
        this.title = title;
      }

      this.$refs.historyModal.show();
      this.loading = true;
      loadDataPromise.then((data) => {
        this.historyData = data;
        this.loading = false;
      });
    },

    getKeyDisplayName(key) {
      if (this.dataMapping && this.dataMapping[key]) {
        return this.dataMapping[key].displayName;
      }
      return key;
    },
    getDisplayValueForKey(key, rawValue) {
      if (this.dataMapping && this.dataMapping[key] && this.dataMapping[key].format) {
        return this.dataMapping[key].format(rawValue);
      }
      return rawValue;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
